import { NavLink } from 'react-router-dom-v5-compat';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { SidebarButton } from '../SidebarButton';

import { useStyles } from './useStyles';

export const SidebarSubmenuItem = ({ className, classes, item, active }) => {
  const styles = useStyles();

  return (
    <SidebarButton
      className={cx(styles.root, className, { [styles.active]: active })}
      classes={{
        ...classes,
        label: item.options?.emptySubmenuItem ? styles.emptyLabel : styles.label,
      }}
      item={item}
      active={active}
      component={NavLink}
      to={item.disableNavigation ? undefined : item.path}
      startIcon={undefined}
    />
  );
};

SidebarSubmenuItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  active: PropTypes.bool,
};

SidebarSubmenuItem.defaultProps = {
  className: '',
  active: false,
};
